function switchShopwareVersion(version) {
    const shopware_5_settings = document.getElementById('shopware_5_settings');
    const shopware_6_settings = document.getElementById('shopware_6_settings');

    if (version === '5') {
        shopware_5_settings.style.display = 'block';
        shopware_6_settings.style.display = 'none';
    } else {
        shopware_5_settings.style.display = 'none';
        shopware_6_settings.style.display = 'block';
    }
}

compiler('[form-shopware-shop-setting-switch-shopware-version]', function(form) {
    console.log('form-magento-shop-setting-switch-version')
    form.addEventListener('change', function(event) {
        const target = event.target;

        if (target && target.matches('[data-switch-api-version]')) {
            switchShopwareVersion(target.value)
        }
    })

    const apiVersion = form.querySelector('[data-switch-api-version]').value;
    switchShopwareVersion(apiVersion)
})